import { z } from 'zod';

export const searchParamsValidator = z.object({
  conversationId: z.optional(z.guid()),
  assistant: z.optional(z.string()),
  chapter: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .transform((val) => {
      if (!val) {
        return undefined;
      }
      const values = Array.isArray(val) ? val : [val];
      const normalized = [
        ...new Set(
          values
            .flatMap((v) => v.split(','))
            .map((v) => v.trim())
            .filter((v) => Boolean(v) && v !== '[]')
        ),
      ];
      return normalized.length > 0 ? normalized : undefined;
    }),
});
